import { SubscriptionProduct } from '../interfaces.enums';

export const BYGGFORSKSERIEN = 1;
export const VAATROMSNORMEN = 3;
export const PRODUCT_SOURCES = [BYGGFORSKSERIEN, VAATROMSNORMEN];

export function productName(sourceId?: number | null): string {
  if (sourceId === BYGGFORSKSERIEN) return 'Byggforskserien';
  if (sourceId === VAATROMSNORMEN) return 'Våtromsnormen';
  return 'Begge (eldre regel)';
}

export function productOfSource(sourceId: number): SubscriptionProduct {
  return sourceId === VAATROMSNORMEN ? SubscriptionProduct.BVN : SubscriptionProduct.BFS;
}

export function sourceOfProduct(product: SubscriptionProduct): number {
  return product === SubscriptionProduct.BVN ? VAATROMSNORMEN : BYGGFORSKSERIEN;
}
